<template>
  <div class="dialog-wrapper">
    <dialog open class="dialog">
      <a class="close" @click.prevent="$emit('close')">
        <font-awesome-icon icon="fas fa-times"></font-awesome-icon>
      </a>

      <h2 class="title mb-3">新增權限</h2>
      
      <div class="content">
        <div class="dropdown rounded">
          <select class="fM rounded px-3 border-c1" v-model="accessType">
            <option v-for="item in accessTypeList" :key="item.value" :value="item.value">{{ item.text }}</option>
          </select>
          <div class="arrow">
            <font-awesome-icon icon="fa-solid fa-caret-down" size="xs"></font-awesome-icon>
          </div>
        </div>
      </div>
      
      <div class="buttons">
        <button
          class="button rounded"
          @click="$emit('action', accessType)"
        >
          <span class="fS">產生連結</span>
        </button>
      </div>

      <div v-if="link != ''" class="mt-2">
        <div class="input rounded border-c1 px-2">
          <input type="text" class="fXS mx-1" v-model="link" />
          <a href="#" class="icon iconButton nowrap mx-1" @click.prevent="copyLink">
            <font-awesome-icon icon="fas fa-copy" size="sm"></font-awesome-icon>
            <span v-if="copied" class="fXS">&nbsp;已複製</span>
            <span v-else class="fXS">&nbsp;複製</span>
          </a>
        </div>
      </div>
    </dialog>
  </div>
</template>

<script>
export default {
  name: 'StoreUserAdd',
  emits: ['action', 'close'],
  props: {
    link: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      copied: false,
      accessTypeList: [
        {
          text: "管理員",
          value: 1
        }
      ],
      accessType: 1
    };
  },
  methods: {
    async copyLink() {
      try {
        await navigator.clipboard.writeText(this.link);
        
        this.copied = true;
        
        setTimeout(() => {
          this.copied = false;
        }, 3000);
      } catch (err) {
        console.error(err);
        alert('複製失敗，請手動複製連結');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-wrapper {
  ol {
    margin-bottom: 0;
  }

  .title {
    text-align: center;
    font-size: clamp(1.125rem, 4.5vw, 1.35rem);
    font-weight: 500;
  }

  .content {
    text-align: center;
    margin-top: 8px;
  }

  .buttons {
    margin-top: 20px;
  }

  .icon-wrapper {
    display: flex;
    justify-content: center;

    img {
      margin-bottom: 10px;
    }
  }
}
</style>